// eslint-ignore
export default 
`<DtTabs :tabList="tabsIcon">
  <template v-slot:tabPanel-1> Content 1 </template>
  <template v-slot:tabPanel-2> Content 2 </template>
  <template v-slot:tabPanel-3> Content 3 </template>
  <template v-slot:tabPanel-4> Content 4 </template>
</DtTabs>

export default {
  data () {
    return {
      tabsIcon: [
        { text: 'Tab with Icon 1', icon: 'fa-calendar-alt' },
        { text: 'Tab with Icon 2', icon: 'fa-user-circle' },
        { text: 'Tab with Icon 3', icon: 'fa-envelope' },
        { text: 'Tab with Icon 4', icon: 'fa-gem'}
      ],
    }
  }
}`;